'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var log = Object.assign(debug('libp2p:circuit:hop'), {
  error: debug('libp2p:circuit:hop:err')
});

var errCode = require('err-code');

var PeerId = require('peer-id');

var _require = require('./utils'),
    validateAddrs = _require.validateAddrs;

var StreamHandler = require('./stream-handler');

var _require2 = require('../protocol'),
    CircuitPB = _require2.CircuitRelay;

var _require3 = require('it-pipe'),
    pipe = _require3.pipe;

var _require4 = require('../../errors'),
    Errors = _require4.codes;

var _require5 = require('./stop'),
    stop = _require5.stop;

var multicodec = require('./../multicodec');
/**
 * @typedef {import('../protocol').ICircuitRelay} ICircuitRelay
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('../transport')} Transport
 */

/**
 * @typedef {Object} HopRequest
 * @property {Connection} connection
 * @property {ICircuitRelay} request
 * @property {StreamHandler} streamHandler
 * @property {Transport} circuit
 */

/**
 * @param {HopRequest} options
 * @returns {Promise<void>}
 */


function handleHop(_x) {
  return _handleHop.apply(this, arguments);
}
/**
 * Performs a HOP request to a relay peer, to request a connection to another
 * peer. A new, virtual, connection will be created between the two via the relay.
 *
 * @param {object} options
 * @param {Connection} options.connection - Connection to the relay
 * @param {ICircuitRelay} options.request
 * @returns {Promise<MuxedStream>}
 */


function _handleHop() {
  _handleHop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var connection, request, streamHandler, circuit, destinationPeer, destinationConnection, stopRequest, destinationStream, sourceStream;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            connection = _ref.connection, request = _ref.request, streamHandler = _ref.streamHandler, circuit = _ref.circuit;

            if (circuit._options.hop.enabled) {
              _context.next = 4;
              break;
            }

            log('HOP request received but we are not acting as a relay');
            return _context.abrupt("return", streamHandler.end({
              type: CircuitPB.Type.STATUS,
              code: CircuitPB.Status.HOP_CANT_SPEAK_RELAY
            }));

          case 4:
            _context.prev = 4;
            validateAddrs(request, streamHandler);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", log.error('invalid hop request via peer %s', connection.remotePeer.toB58String(), _context.t0));

          case 11:
            if (request.dstPeer) {
              _context.next = 14;
              break;
            }

            log('HOP request received but we do not receive a dstPeer');
            return _context.abrupt("return");

          case 14:
            // Get the connection to the destination (stop) peer
            destinationPeer = new PeerId(request.dstPeer.id);
            destinationConnection = circuit._connectionManager.get(destinationPeer);

            if (!(!destinationConnection && !circuit._options.hop.active)) {
              _context.next = 19;
              break;
            }

            log('HOP request received but we are not connected to the destination peer');
            return _context.abrupt("return", streamHandler.end({
              type: CircuitPB.Type.STATUS,
              code: CircuitPB.Status.HOP_NO_CONN_TO_DST
            }));

          case 19:
            if (destinationConnection) {
              _context.next = 21;
              break;
            }

            return _context.abrupt("return");

          case 21:
            // Handle the incoming HOP request by performing a STOP request
            stopRequest = {
              type: CircuitPB.Type.STOP,
              dstPeer: request.dstPeer,
              srcPeer: request.srcPeer
            };
            _context.prev = 22;
            _context.next = 25;
            return stop({
              connection: destinationConnection,
              request: stopRequest
            });

          case 25:
            destinationStream = _context.sent;
            _context.next = 31;
            break;

          case 28:
            _context.prev = 28;
            _context.t1 = _context["catch"](22);
            return _context.abrupt("return", log.error(_context.t1));

          case 31:
            log('hop request from %s is valid', connection.remotePeer.toB58String());
            streamHandler.write({
              type: CircuitPB.Type.STATUS,
              code: CircuitPB.Status.SUCCESS
            });
            sourceStream = streamHandler.rest(); // Short circuit the two streams to create the relayed connection

            return _context.abrupt("return", pipe(sourceStream, destinationStream, sourceStream));

          case 35:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 8], [22, 28]]);
  }));
  return _handleHop.apply(this, arguments);
}

function hop(_x2) {
  return _hop.apply(this, arguments);
}
/**
 * Performs a CAN_HOP request to a relay peer, in order to understand its capabilities.
 *
 * @param {object} options
 * @param {Connection} options.connection - Connection to the relay
 * @returns {Promise<boolean>}
 */


function _hop() {
  _hop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var connection, request, _yield$connection$new, stream, streamHandler, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            connection = _ref2.connection, request = _ref2.request;
            _context2.next = 3;
            return connection.newStream([multicodec.relay]);

          case 3:
            _yield$connection$new = _context2.sent;
            stream = _yield$connection$new.stream;
            // Send the HOP request
            streamHandler = new StreamHandler({
              stream: stream
            });
            streamHandler.write(request);
            _context2.next = 9;
            return streamHandler.read();

          case 9:
            response = _context2.sent;

            if (response) {
              _context2.next = 12;
              break;
            }

            throw errCode(new Error('HOP request had no response'), Errors.ERR_HOP_REQUEST_FAILED);

          case 12:
            if (!(response.code === CircuitPB.Status.SUCCESS)) {
              _context2.next = 15;
              break;
            }

            log('hop request was successful');
            return _context2.abrupt("return", streamHandler.rest());

          case 15:
            log('hop request failed with code %d, closing stream', response.code);
            streamHandler.close();
            throw errCode(new Error("HOP request failed with code ".concat(response.code)), Errors.ERR_HOP_REQUEST_FAILED);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _hop.apply(this, arguments);
}

function canHop(_x3) {
  return _canHop.apply(this, arguments);
}
/**
 * Creates an unencoded CAN_HOP response based on the Circuits configuration
 *
 * @param {Object} options
 * @param {Connection} options.connection
 * @param {StreamHandler} options.streamHandler
 * @param {Transport} options.circuit
 * @private
 */


function _canHop() {
  _canHop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var connection, _yield$connection$new2, stream, streamHandler, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            connection = _ref3.connection;
            _context3.next = 3;
            return connection.newStream([multicodec.relay]);

          case 3:
            _yield$connection$new2 = _context3.sent;
            stream = _yield$connection$new2.stream;
            // Send the HOP request
            streamHandler = new StreamHandler({
              stream: stream
            });
            streamHandler.write({
              type: CircuitPB.Type.CAN_HOP
            });
            _context3.next = 9;
            return streamHandler.read();

          case 9:
            response = _context3.sent;
            _context3.next = 12;
            return streamHandler.close();

          case 12:
            if (!(!response || response.code !== CircuitPB.Status.SUCCESS)) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", false);

          case 14:
            return _context3.abrupt("return", true);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _canHop.apply(this, arguments);
}

function handleCanHop(_ref4) {
  var connection = _ref4.connection,
      streamHandler = _ref4.streamHandler,
      circuit = _ref4.circuit;
  var canHop = circuit._options.hop.enabled;
  log('can hop (%s) request from %s', canHop, connection.remotePeer.toB58String());
  streamHandler.end({
    type: CircuitPB.Type.STATUS,
    code: canHop ? CircuitPB.Status.SUCCESS : CircuitPB.Status.HOP_CANT_SPEAK_RELAY
  });
}

module.exports = {
  handleHop: handleHop,
  hop: hop,
  canHop: canHop,
  handleCanHop: handleCanHop
};